import { render, staticRenderFns } from "./stu_dangan_tlyy.vue?vue&type=template&id=b997f450&"
import script from "./stu_dangan_tlyy.vue?vue&type=script&lang=js&"
export * from "./stu_dangan_tlyy.vue?vue&type=script&lang=js&"
import style0 from "./stu_dangan_tlyy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports